// extracted by mini-css-extract-plugin
export default {"preloader":"Loder_preloader__iW1ep"};